// 用户角色列表
const useRole = [
  {
    label: '全部用户角色',
    value: '',
  },
  {
    label: '医生',
    value: 2,
  },
  {
    label: '员工',
    value: 1,
  },
];
// 用户行为列表
const userBehaviorList = [];

// 表格数据
const tableData = [];
// 表格显示用户行为匹配规则
const BehaviorTypeData = {};
// 向外暴露，利于外部引用
export { useRole, userBehaviorList, tableData, BehaviorTypeData };
